import produce from 'immer'
import { Reducer } from 'redux';

import { QAComment, QASection, QASectionNode } from 'interfaces/qa';
import {
  SET_QA_SECTION_ID,
  SET_QA_SECTIONS,
  SET_QA_SECTIONS_MAP,
  SET_QA_ROOT_SECTIONS,
  SET_QA_PICKED_SECTION,
  SET_QA_NODE_MAP,
  SET_QA_COMMENT_MAP
} from 'redux/actions/types'
import { Flavour } from 'types/Flavour';

interface QAState {
  sectionId: string;
  sections: Record<Flavour, QASectionNode>;
  sectionsMap: Map<string, QASection>;
  rootSections: QASection[];
  pickedSection: QASectionNode;
  nodeMap: Map<string, QASection>;
  commentMap: Map<string, QAComment>
}

const initialState: QAState = {
  sectionId: null,
  sections: null,
  sectionsMap: null,
  rootSections: null,
  pickedSection: null,
  nodeMap: null,
  commentMap: null
}

const qa:Reducer<QAState, any> = (state = initialState, action) => {
  switch (action.type) {
    case SET_QA_SECTION_ID:
      return produce(state, draft => {
        draft.sectionId = action.sectionId
      })
    case SET_QA_SECTIONS:
      return produce(state, draft => {
        draft.sections = action.sections
      })
    case SET_QA_SECTIONS_MAP:
      return produce(state, draft => {
        draft.sectionsMap = action.sectionsMap
      })
    case SET_QA_ROOT_SECTIONS:
      return produce(state, draft => {
        draft.rootSections = action.rootSections
      })
    case SET_QA_PICKED_SECTION:
      return produce(state, draft => {
        draft.pickedSection = action.pickedSection
      })
    case SET_QA_NODE_MAP:
      return produce(state, draft => {
        draft.nodeMap = action.nodeMap
      })
    case SET_QA_COMMENT_MAP:
      return produce(state, draft => {
        draft.commentMap = action.commentMap
      })
    default:
      return state
  }
}

export default qa
